<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">特集付替設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw1319Model.dispOrderCode" readonly>
          </div>
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw1319Model.dispMedium" readonly>
          </div>
          <label class="list-input-title">Pコード</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw1319InputVO.pcode" readonly class="pcode">
          </div>
          <label class="list-input-title">商品名</label>
          <div class="list-input-content">
            <input type="text" [(ngModel)]="kymw1319InputVO.guideGoodsName" readonly>
          </div>
        </div>

        <div class="element-column">
          <div style="height: 248px;">
            <h2>設定済特集一覧</h2>
            <wj-flex-grid #dtg_selectedFeatureList id="dtg_selectedFeatureList"
              [itemsSource]="kymw1319Model.selectedFeatureList" [headersVisibility]="'Column'" [allowSorting]="false"
              sortableColumns="false" [allowDragging]="'None'" [selectionMode]="'Row'" [isReadOnly]="true"
              [allowResizing]="'Columns'">
              <wj-flex-grid-column [header]="'受注コード'" [binding]="'OrderCode'" [width]="90" [minWidth]="5"
                [isReadOnly]="true"></wj-flex-grid-column>
              <wj-flex-grid-column [header]="'特集'" [binding]="'DispFeature'" [width]="500" [minWidth]="5"
                [isReadOnly]="true"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>

          <div class="column-list">
            <label class="list-input-title">設定候補特集</label>
            <div class="list-input-content">
              <select id="cmb_ItemCode" #cmb_ItemCode [tabindex]="0" [disabled]="!editMode"
                [(ngModel)]="kymw1319Model.selectedFeatureCode" (change)="eventFeatureCode_CHANGEHandler()">
                <option value=""></option>
                <ng-template ngFor let-item [ngForOf]="kymw1319Model.featureInfoList">
                  <option value="{{item.FeatureCode}}">{{item.FeatureCode}}:{{item.FeatureName}}</option>
                </ng-template>
              </select>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" #btn_Set class="btn-primary" [tabindex]="0" [disabled]="!editMode"
            (click)="eventSet_CLICKHandler()">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>